import { Injectable } from '@angular/core';
import { User } from './user';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UsersService } from '../users/users.service';

const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private user: User;
  private userObs = new Subject<any>();

  constructor(
    private router: Router,
    private http: HttpClient,
    private userService: UsersService
    ) {}

  resetPassword(email: string, recaptchaKey: string): Observable<any> {
    return this.http.post(`${environment.api}/password/reset`, {
      email: email,
      recaptchaKey: recaptchaKey
    });
  }

  lorealLogin() {
    return this.http.post(
      `${environment.api}/panel/azure/redirect-uri`,
      {
        redirectUri: `${location.origin}/ssologin`
      }
    );
  }

  lorealLoginGetToken(code: string) {
    return this.http.post(
      `${environment.api}/panel/azure/check-credentials`,
      {
        code,
        redirectUri: `${location.origin}/ssologin`
      }
    );
  }

  // login(username: string, password: string): Observable<any> {
  //   return this.http.post(`${environment.api}/login`, {
  //     username: username,
  //     password: password
  //   })
  //   .pipe(
  //     map((data: any) => {
  //       if (data && data.token) {
  //         sessionStorage.setItem('userToken', JSON.stringify(data));
  //       }
  //     })
  //   );
  // }

  // sendCode(username: string, code: string) {
  //   return this.http
  //     .post(`${environment.api}/login/obtain-token`, {
  //       username: username,
  //       code: code
  //     })
  //     .pipe(
  //       map((data: any) => {
  //         if (data && data.token) {
  //           sessionStorage.setItem('userToken', JSON.stringify(data));
  //         }
  //       })
  //     );
  // }

  logout() {
    this.removeToken();
    setTimeout(() => {
      this.userService.resetMe();
    });
  }

  removeToken() {
    sessionStorage.removeItem('userToken');
    this.router.navigate(['/auth']);
  }

  getUser(): Observable<any> {
    return this.userObs.asObservable();
  }

  isAuthenticated() {
    const data = sessionStorage.getItem('userToken');

    if (data && JSON.parse(data).token) {
      const decodedToken = helper.decodeToken(JSON.parse(data).token);

      const expirationDate = helper.getTokenExpirationDate(
        JSON.parse(data).token
      );
      const isExpired = helper.isTokenExpired(JSON.parse(data).token);

      if (!isExpired) {
        return true;
      }
    }

    return false;
  }
}
